namespace Matrix.Indexation {
    export interface PriceTypeForm {
        PriceTypeCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class PriceTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.PriceType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PriceTypeForm.init)  {
                PriceTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(PriceTypeForm, [
                    'PriceTypeCode', w0,
                    'Name', w0,
                    'DefaultSortOrder', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
